<script>
    export let status;
</script>

{#if status?.delivery == undefined}
    <span>Lädt</span>
{:else if status?.delivery === "successful" && status?.visible === true}
    <span class="delivered">Veröffentlicht</span>
{:else if status?.delivery === "successful" && status?.visible === false}
    <span class="hidden">Verborgen</span>
{:else if status?.delivery === "scheduled"}
    <span class="scheduled">Geplant</span>
{/if}

<style>
    span {
        font-size: 0.8rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        display: inline-block;
        background-color: #E0D8D2;
        color: rgb(117, 107, 100);
    }
    
    .scheduled {        
        background-color: rgb(255, 228, 140);
        color: #8b4513;
    }

    .delivered {        
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
    }

    .hidden {        
        background-color: rgb(255, 210, 210);
        color: rgb(210, 0, 0);
    }
</style>